
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "binding",
components: {
XButton
},
data() {
return {
id: "",
isShow: false,
};
},
methods: {
xgmm() {
this.$router.push({name: "xgmm", params: {id: this.id}});
},
closeaccount() {
var _this = this;
let unionid = localStorage.getItem('unionid');
let opid
let obj = {}
this.$http.post('/api/v1/wechat/' + unionid + '/token', {'account': this.id}).then(res => {
opid = res.data.userid
obj = {
headers: {
token: res.data.token,
opid
}
};
})

this.$vux.confirm.show({
title: "",
content: "删除账号后，您的所有信息将被删除，是否确认删除账号？",
onConfirm() {
_this.$http
.delete("/api/v1/accounts/" + opid, obj)
.then(function (response) {
if (response.status === 204) {
_this.$vux.alert.show({
title: "",
content: "删除成功",
onHide() {
location.reload();
_this.show ? this.$router.push({path: '/glzh'}) : this.$router.push({path: '/login'})
}
});
}
})
.catch(function (error) {
_this.$vux.alert.show({
title: "",
content: "服务器错误，请稍后重试"
});
if (
JSON.parse(error.response.data.error_message).faultcode ==
"11011"
) {
_this.$vux.alert.show({
title: "",
content: JSON.parse(error.response.data.error_message)
.zh_string
});
} else if (error.response) {
console.log(error.response.data);
} else if (error.request) {
console.log(error.request);
} else {
console.log("Error", error.message);
}
});
}
});
},
unbound() {
let openid = localStorage.getItem('openid');
let unionid = localStorage.getItem('unionid');
this.$http.post('/api/v1/wechat/' + unionid + '/token', {'account': this.id}).then(res => {
let opid = res.data.userid
let obj = {
headers: {
token: res.data.token,
opid
}
};
this.$http.delete('/api/v1/wechat/' + unionid + '?userid=' + opid, obj).then((res) => {
console.log(res)
this.$router.push({path: '/glzh'})
})
})

}
},
beforeRouteEnter(to, from, next) {
if (from.name === "glzh") {
next(vm => {
vm.id = vm.$route.params.id;
AjaxPlugin.$http.post('/api/v1/wechat/' + localStorage.getItem('unionid') + '/token', {'account': vm.id}).then((res) => {
let opid = res.data.userid
let obj = {headers: {token: res.data.token, opid}};
AjaxPlugin.$http.get('/api/v1/accounts/' + res.data.userid, obj).then((res) => {
res.data.forEach(item => {
if (item.type === 'ADMIN' || item.type === 'SRVP') {
vm.isShow = true
}
})
})
})
});
} else {
next();
}
}
};



// WEBPACK FOOTER //
// ./src/components/binding.vue